import { useTranslation } from 'react-i18next';
import { useDeviceDimensions } from '@/hooks/useDeviceDimensions';
import LinkDrawer from '../LinkDrawer';
import { LinkModal } from '../LinkModal';

const TOSModal = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
  const { t } = useTranslation();
  const { isDesktopDimensions } = useDeviceDimensions();
  const tosUrl = t('general.links.tos');

  return isDesktopDimensions ? (
    <LinkModal open={open} onClose={onClose} src={tosUrl} title="Terms of Use" />
  ) : (
    <LinkDrawer
      url={tosUrl}
      title="Terms of Use"
      isOpen={open}
      handleClose={onClose}
    />
  );
};

export { TOSModal };
